module.exports = __webpack_public_path__ + "img/yaoshu.51079ec3.png";